import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '../../public/assets/icons/delete-warning-icon.svg'


const _hoisted_1 = { class: "my-reports" }
const _hoisted_2 = { class: "my-reports__header-wrapper" }
const _hoisted_3 = { id: "my-report-filters" }
const _hoisted_4 = { class: "my-reports__header-section" }
const _hoisted_5 = { class: "container2" }
const _hoisted_6 = { class: "report-card__header" }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title", "aria-label", "onClick", "onKeydown"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "quick-action-box" }
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = { class: "quick-action-box" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "quick-action-box" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "quick-action-box" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "quick-action-box" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["title", "onClick"]
const _hoisted_23 = { class: "quick-action-box" }
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "report-card__footer" }
const _hoisted_26 = {
  key: 0,
  class: "deleted__messaged"
}
const _hoisted_27 = {
  key: 1,
  class: "modal__center-heading"
}
const _hoisted_28 = {
  key: 0,
  class: "table-schedules-used-by-report"
}
const _hoisted_29 = { id: "table-schedules-used-by-report" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "attensi-teal-05" }
const _hoisted_32 = { class: "graph-data__header" }
const _hoisted_33 = { class: "search-wrapper__container" }
const _hoisted_34 = { class: "search-wrapper" }
const _hoisted_35 = { class: "filter-modal filters" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "columns-items" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "email" }
const _hoisted_40 = { class: "filter_selection_div_continue_button" }
const _hoisted_41 = { class: "quick-view-title" }
const _hoisted_42 = { class: "schedule-quick-view-container modal-scrollbar" }
const _hoisted_43 = { class: "filter_selection impersonation-picker-modal" }
const _hoisted_44 = { class: "modal-title" }
const _hoisted_45 = { class: "mt-10 report-preview-description" }
const _hoisted_46 = { class: "mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttensiButton = _resolveComponent("AttensiButton")!
  const _component_AttensiInput = _resolveComponent("AttensiInput")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_ErrorComponent = _resolveComponent("ErrorComponent")!
  const _component_AttensiCard = _resolveComponent("AttensiCard")!
  const _component_ReportTypeBadge = _resolveComponent("ReportTypeBadge")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_ReportDownloadButton = _resolveComponent("ReportDownloadButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_RepetitionsVisualizationModal = _resolveComponent("RepetitionsVisualizationModal")!
  const _component_KnowledgeVisualizationModalVue = _resolveComponent("KnowledgeVisualizationModalVue")!
  const _component_PlaythroughsVisualizationModal = _resolveComponent("PlaythroughsVisualizationModal")!
  const _component_NoDataModal = _resolveComponent("NoDataModal")!
  const _component_ReportQuickView = _resolveComponent("ReportQuickView")!
  const _component_ImpersonatableUserPicker = _resolveComponent("ImpersonatableUserPicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          id: "my-report-actions",
          class: "container"
        }, [
          _createElementVNode("div", { class: "text-right" })
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t('report-home-page.HEADING')), 1 /* TEXT */),
            _createVNode(_component_AttensiButton, {
              size: "small",
              shape: "round",
              outline: "",
              onClick: _ctx.createNewReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('report-home-page.NEW_REPORT_BTN')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ]),
          _createVNode(_component_AttensiInput, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            name: 'Search',
            label: "Search",
            placeholder: _ctx.t('report-home-page.SEARCH_PLACEHOLDER'),
            type: "search"
          }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loadingData.reports)
            ? (_openBlock(), _createBlock(_component_LoadingComponent, {
                key: 0,
                message: 'Please wait while we load your reports',
                heading: 'Loading Reports'
              }))
            : (_ctx.errorData.reports)
              ? (_openBlock(), _createBlock(_component_AttensiCard, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ErrorComponent)
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredReports, (report, index) => {
                  return (_openBlock(), _createBlock(_component_AttensiCard, {
                    key: index,
                    "drop-shadow": false,
                    border: true,
                    class: "report-card"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_ReportTypeBadge, {
                          report: report,
                          "display-text": false
                        }, null, 8 /* PROPS */, ["report"]),
                        _createElementVNode("h2", {
                          title: report.title
                        }, [
                          _createTextVNode(_toDisplayString(report.title) + " ", 1 /* TEXT */),
                          (report.lock?.isLocked)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "report-card__lock-icon",
                                title: _ctx.t('report-home-page.LOCKED_INDICATOR_TOOLTIP')
                              }, [
                                _createVNode(_component_MenuIcon, { type: 'lock' })
                              ], 8 /* PROPS */, _hoisted_8))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_7),
                        _createElementVNode("div", {
                          class: "report-card__header--dropdpwn",
                          role: "button",
                          tabindex: "0",
                          title: _ctx.t('schedules.BUTTON_QUICK_ACTIONS'),
                          "aria-label": _ctx.t('schedules.BUTTON_QUICK_ACTIONS'),
                          onClick: ($event: any) => (_ctx.toggleDropdown(index)),
                          onKeydown: _withKeys(($event: any) => (_ctx.toggleDropdown(index)), ["enter"])
                        }, [
                          _createVNode(_component_MenuIcon, { type: 'report-menu' })
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_9),
                        (_ctx.selectedItem === index)
                          ? (_openBlock(), _createBlock(_component_AttensiCard, {
                              key: 0,
                              ref_for: true,
                              ref: "dropdownContainer",
                              "drop-shadow": false,
                              border: true,
                              class: "report-card__header--dropdown",
                              padded: false
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("ul", null, [
                                  _createElementVNode("li", {
                                    onClick: ($event: any) => (_ctx.openQuickViewModal(report))
                                  }, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_MenuIcon, { type: 'quick-view' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('schedules.BUTTON_QUICK_VIEW_SCHEDULE')), 1 /* TEXT */)
                                    ])
                                  ], 8 /* PROPS */, _hoisted_10),
                                  _createElementVNode("li", {
                                    class: _normalizeClass({ 'quick-action--disabled': _ctx.isEditLocked(report) }),
                                    title: 
                      _ctx.isEditLocked(report)
                        ? _ctx.t('report-home-page.LOCKED_EDIT_TOOLTIP')
                        : ''
                    ,
                                    onClick: ($event: any) => (_ctx.onEditClick(report))
                                  }, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_MenuIcon, { type: 'edit-report' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('report-home-page.EDIT_REPORT_BTN')), 1 /* TEXT */)
                                    ])
                                  ], 10 /* CLASS, PROPS */, _hoisted_12),
                                  _createElementVNode("li", {
                                    onClick: ($event: any) => (_ctx.createScheduleForReport(report))
                                  }, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createVNode(_component_MenuIcon, { type: 'schedule-report' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('report-home-page.SCHEDULE_REPORT_BTN')), 1 /* TEXT */)
                                    ])
                                  ], 8 /* PROPS */, _hoisted_14),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", {
                                      class: "quick-action-box",
                                      onClick: ($event: any) => (_ctx.copyReport(report.id))
                                    }, [
                                      _createVNode(_component_MenuIcon, { type: 'copy' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('copy-report.DUPLICATE_REPORT_BUTTON')), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_16)
                                  ]),
                                  _createElementVNode("li", {
                                    onClick: ($event: any) => (_ctx.openModalShareReport(report))
                                  }, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_MenuIcon, { type: 'share' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('report-home-page.SHARE_REPORT_BTN')), 1 /* TEXT */)
                                    ])
                                  ], 8 /* PROPS */, _hoisted_17),
                                  _createCommentVNode(" Download as User "),
                                  (_ctx.reportPreviewEnabled() && report.dynamicReport)
                                    ? (_openBlock(), _createElementBlock("li", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.openImpersonatableUsersModal(report))
                                      }, [
                                        _createElementVNode("div", _hoisted_20, [
                                          _createVNode(_component_MenuIcon, { type: 'download' }),
                                          _createTextVNode(" " + _toDisplayString(_ctx.t('report-preview.DOWNLOAD_AS_USER_BUTTON')), 1 /* TEXT */)
                                        ])
                                      ], 8 /* PROPS */, _hoisted_19))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", {
                                      class: "quick-action-box",
                                      onClick: ($event: any) => (_ctx.downloadReportLogs(report))
                                    }, [
                                      _createVNode(_component_MenuIcon, { type: 'download' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('download-logs.BUTTON')), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_21)
                                  ]),
                                  _createElementVNode("li", {
                                    class: _normalizeClass({
                      'quick-action--disabled': _ctx.isDeleteLocked(report),
                    }),
                                    title: 
                      _ctx.isDeleteLocked(report)
                        ? _ctx.t('report-home-page.LOCKED_DELETE_TOOLTIP')
                        : ''
                    ,
                                    onClick: ($event: any) => (_ctx.onDeleteClick(report))
                                  }, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_MenuIcon, { type: 'delete' }),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.t('report-home-page.CARD_DELETE_BTN')), 1 /* TEXT */)
                                    ])
                                  ], 10 /* CLASS, PROPS */, _hoisted_22)
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", {
                        class: "report-card__content",
                        title: report.description
                      }, _toDisplayString(report.description), 9 /* TEXT, PROPS */, _hoisted_24),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_ReportDownloadButton, {
                          report: report,
                          "full-width": true,
                          text: _ctx.t('report-home-page.CARD_DOWNLOAD_BTN'),
                          onShowNoDataModal: _ctx.showNoDataModel
                        }, null, 8 /* PROPS */, ["report", "text", "onShowNoDataModal"])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createCommentVNode(" Delete Report Modal "),
    _createVNode(_component_Modal, {
      show: _ctx.isModalOpened,
      size: "medium",
      onClose: _ctx.closeModal
    }, {
      header: _withCtx(() => [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "delete-icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "report warning"
          })
        ], -1 /* CACHED */)),
        (!_ctx.lodash.isEmpty(_ctx.reportSchedules))
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
              _createElementVNode("b", null, _toDisplayString(_ctx.reportToDelete?.title), 1 /* TEXT */),
              _cache[8] || (_cache[8] = _createTextVNode(" can't be deleted because it is being used by the following schedules: ", -1 /* CACHED */))
            ]))
          : (_openBlock(), _createElementBlock("h4", _hoisted_27, _toDisplayString(_ctx.t('report-home-page.DELETE_MODAL_HEADING')), 1 /* TEXT */))
      ]),
      body: _withCtx(() => [
        (!_ctx.lodash.isEmpty(_ctx.reportSchedules))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("table", _hoisted_29, [
                _createElementVNode("tbody", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Schedule ID"),
                    _createElementVNode("th", null, "Title")
                  ], -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportSchedules, (schedule) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: schedule.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(schedule.id), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(schedule.title), 1 /* TEXT */)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.t('report-home-page.DELETE_REPORT_NAME_SUBTEXT')) + " ", 1 /* TEXT */),
                _createElementVNode("b", _hoisted_31, _toDisplayString(_ctx.reportToDelete?.title), 1 /* TEXT */),
                _cache[11] || (_cache[11] = _createTextVNode("? ", -1 /* CACHED */))
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.t('report-home-page.DELETE_HELPER_TEXT')), 1 /* TEXT */),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */))
            ])),
        _createVNode(_component_AttensiButton, {
          outline: "",
          shape: "round",
          size: "small",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('report-home-page.DELETE_CANCEL_BTN')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]),
        (_ctx.lodash.isEmpty(_ctx.reportSchedules))
          ? (_openBlock(), _createBlock(_component_AttensiButton, {
              key: 2,
              class: "delete-button",
              size: "small",
              shape: "round",
              theme: "red-alert",
              onClick: _ctx.deleteReport
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('report-home-page.DELETE_CONFIRM_BTN')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show", "onClose"]),
    _createVNode(_component_Modal, {
      show: _ctx.isGraphModalOpened,
      size: "large"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.visualizationHeadingText), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString(_ctx.visualizationHelperText), 1 /* TEXT */)
          ]),
          _createElementVNode("div", {
            class: "graph-data__close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isGraphModalOpened = false))
          }, [
            _createVNode(_component_MenuIcon, { type: 'close-btn' })
          ])
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.selectedReport?.type === 'repetitions')
          ? (_openBlock(), _createBlock(_component_RepetitionsVisualizationModal, {
              key: 0,
              report: _ctx.selectedReport,
              onShowNoDataModal: _ctx.showNoDataModel
            }, null, 8 /* PROPS */, ["report", "onShowNoDataModal"]))
          : _createCommentVNode("v-if", true),
        (_ctx.selectedReport?.type === 'knowledge')
          ? (_openBlock(), _createBlock(_component_KnowledgeVisualizationModalVue, {
              key: 1,
              report: _ctx.selectedReport,
              onShowNoDataModal: _ctx.showNoDataModel
            }, null, 8 /* PROPS */, ["report", "onShowNoDataModal"]))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createVNode(_component_PlaythroughsVisualizationModal, { report: _ctx.selectedReport }, null, 8 /* PROPS */, ["report"]), [
          [_vShow, _ctx.selectedReport?.type === 'playthroughs']
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_NoDataModal, {
      show: _ctx.showNoData,
      onClose: _cache[2] || (_cache[2] = () => (_ctx.showNoData = false))
    }, null, 8 /* PROPS */, ["show"]),
    _createCommentVNode(" Share Report Modal "),
    _createVNode(_component_Modal, {
      show: _ctx.isShareReportModalOpened,
      size: "medium",
      onClose: _ctx.closeShareReportModal
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", null, _toDisplayString(_ctx.t('report-home-page.SHARE_REPORT_HEADING')), 1 /* TEXT */)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            (_ctx.users.length > 0)
              ? (_openBlock(), _createBlock(_component_AttensiInput, {
                  key: 0,
                  modelValue: _ctx.searchUsers,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchUsers) = $event)),
                  name: "demo-search",
                  placeholder: _ctx.t('report-user-filter.MODAL_SEARCH_PLACEHOLDER'),
                  type: "search"
                }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.id,
                class: "filter_selection_item",
                onClick: ($event: any) => (_ctx.selectUser(user))
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                    type: "checkbox",
                    value: user
                  }, null, 8 /* PROPS */, _hoisted_38), [
                    [_vModelCheckbox, _ctx.selectedUsers]
                  ]),
                  _createTextVNode(" " + _toDisplayString(user.name) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(user.description), 1 /* TEXT */)
                ])
              ], 8 /* PROPS */, _hoisted_36))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_AttensiButton, {
              size: "small",
              theme: "portal-blue",
              class: "attensi-button-purple",
              shape: "round",
              onClick: _ctx.clickShare
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('report-home-page.SHARE_REPORT_BTN')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show", "onClose"]),
    _createCommentVNode(" Quick View Modal "),
    _createVNode(_component_Modal, {
      show: _ctx.isQuickViewModalOpened,
      size: "medium",
      onClose: _ctx.closeQuickViewModal
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t('report-home-page.QUICK_VIEW')), 1 /* TEXT */)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_ReportQuickView, {
            report: _ctx.reportQuickView,
            "created-by-name": _ctx.getUserName(_ctx.reportQuickView.ownerId),
            "updated-by-name": _ctx.getUserName(_ctx.reportQuickView.updatedBy)
          }, null, 8 /* PROPS */, ["report", "created-by-name", "updated-by-name"])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show", "onClose"]),
    _createCommentVNode(" Download as User (Impersonate) Modal "),
    _createVNode(_component_Modal, {
      show: _ctx.isImpersonatableUsersModalOpened,
      onClose: _ctx.closeImpersonatedUserModal
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", {
            class: "modal-close-button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeImpersonatedUserModal && _ctx.closeImpersonatedUserModal(...args)))
          }, [
            _createVNode(_component_MenuIcon, { type: 'black-close-arrow' })
          ]),
          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t('report-preview.MODAL_TITLE')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", null, _toDisplayString(_ctx.t('report-preview.MODAL_DESCRIPTION_PREVIEW')), 1 /* TEXT */),
            _createElementVNode("div", null, _toDisplayString(_ctx.t('report-preview.MODAL_DESCRIPTION_ROLES')), 1 /* TEXT */)
          ]),
          _createVNode(_component_ImpersonatableUserPicker, {
            modelValue: _ctx.selectedImpersonatedUser,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedImpersonatedUser) = $event)),
            options: _ctx.impersonatableUsers,
            class: "mt-10"
          }, null, 8 /* PROPS */, ["modelValue", "options"]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_ReportDownloadButton, {
              report: _ctx.reportQuickView,
              text: _ctx.t('report-preview.DOWNLOAD_BUTTON'),
              "impersonated-user-id": 
              _ctx.lodash.isNumber(Number(_ctx.selectedImpersonatedUser?.id))
                ? Number(_ctx.selectedImpersonatedUser?.id)
                : undefined
            ,
              onShowNoDataModal: _ctx.handleImpersonatedUserNoDataModal
            }, null, 8 /* PROPS */, ["report", "text", "impersonated-user-id", "onShowNoDataModal"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show", "onClose"]),
    _createVNode(_component_NoDataModal, {
      show: _ctx.isImpersonatedUserNoDataModalOpened,
      onClose: _ctx.closeImpersonatedUserNoDataModal
    }, null, 8 /* PROPS */, ["show", "onClose"])
  ], 64 /* STABLE_FRAGMENT */))
}